<template>
	<el-row class="container">
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'">
				<div v-if="!collapsed" class="all-title">
					<div style="text-align: center; font-size: 18px; font-weight: 550;">运营管理平台</div>
				</div>
				<div v-if="collapsed" class="simple-title">
					XZ
				</div>
				<!--导航菜单-->
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" unique-opened router v-if="!collapsed" background-color="#285ccd">
					<template v-for="(item,index) in $router.options.routes">
						<div v-if="!item.hidden" v-bind:key="index" class="menu-all-list">
							<el-submenu :index="index+''" v-if="!item.leaf" class="menu-parent-list">
								<template slot="title">
									<div class="menu-parent">
										<i :class="item.iconCls"></i>{{item.name}}
									</div>
								</template>
								<!-- <el-menu-item class="menu-list menu-child-list" v-for="child in item.children" :index="child.path" :key="child.path">
									<div v-if="!child.hidden">{{child.name}}</div>
								</el-menu-item> -->
								<el-menu-item class="menu-list menu-child-list" v-for="child in item.children" :index="child.path" :key="child.path" 
									v-if="(!child.hidden && !child.isAdmin) || (!child.hidden && child.isAdmin && isAdmin)">
									<div>{{child.name}}</div>
								</el-menu-item>
							</el-submenu>
							<el-menu-item class="menu-list" v-if="item.leaf&&item.children.length>0" :index="item.children[0].path">
								<i :class="item.iconCls"></i>{{item.children[0].name}}
							</el-menu-item>
						</div>
					</template>
				</el-menu>
				<!--导航菜单-折叠后-->
				<ul class="el-menu collapsed small-menu-body" v-if="collapsed" ref="menuCollapsed">
					<li v-bind:key="index" v-for="(item,index) in $router.options.routes" class="el-submenu item">
						<div v-if="!item.hidden">
							<template v-if="!item.leaf">
								<div class="small-menu-list" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
								<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)">
									<!-- <li v-for="child in item.children" :key="child.path" class="el-menu-item small-menu-list-child" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">
										<div v-if="!child.hidden">{{child.name}}</div>
									</li> -->
									<li v-for="child in item.children" :key="child.path" 
										class="el-menu-item small-menu-list-child" 
										style="padding-left: 40px;" 
										:class="$route.path==child.path?'is-active':''" 
										@click="$router.push(child.path)"
										v-if="(!child.hidden && !child.isAdmin) || (!child.hidden && child.isAdmin && isAdmin)">
										<div>{{child.name}}</div>
									</li>
								</ul>
							</template>
							<template v-else>
								<li>
									<div class="small-menu-list" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
								</li>
							</template>
						</div>
                    </li>
                </ul>
            </aside>
			<section class="content-container">
				<el-col :span="24" class="header">
					<el-col :xs="2" :sm="2" :md="2" :lg="2">
						<div class="tools" @click.prevent="collapse" style="margin-bottom: 64px;">
							<i class="fa fa-align-justify" style="vertical-align:middle; color: #353f4f;"></i>
						</div>
					</el-col>
					<el-col :xs="16" :sm="16" :md="16" :lg="16" class="breadcrumb-container">
						<strong class="title">{{$route.name}}</strong>
					</el-col>
					<el-col :xs="6" :sm="6" :md="6" :lg="6" class="userinfo">
						<el-dropdown trigger="hover">
							<span class="el-dropdown-link userinfo-inner">
								<!-- <img :src="this.sysUserAvatar" />  -->
								<img src="../assets/user2.png" />
								{{sysUserName}}
							</span>
							<el-dropdown-menu slot="dropdown">
								<router-link class='inlineBlock' to="/" style="text-decoration:none; color: black;">
									<el-dropdown-item>
										首页
									</el-dropdown-item>
								</router-link>
								<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-col>
				</el-col>
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
	</el-row>
</template>

<script>
    import Screenfull from '../components/Screenfull';
    import { getMaintainListPage, removeMaintain, batchRemoveMaintain } from '../api/api';

    export default {
        components: {
            Screenfull
        },
        data() {
            return {
                sysName: 'SMART-CHARGE',
                collapsed: false,
                sysUserName: '',
                sysUserAvatar: '',
				isAdmin: false,
                form: {
                    name: '',
                    region: '',
                    date1: '',
                    date2: '',
                    delivery: false,
                    type: [],
                    resource: '',
                    desc: ''
                },
                dialogVisible: false,
                maintains: [],
                total: 0,
                listLoading: false,
                sels: [],//列表选中列

                form: {
                    strTitle: '',
                    strContent: '',
                    cStartTime: '',
                    cEndTime: '',
                    uStartTime: '',
                    uEndTime: ''
                },
                listQuery: {
                    curPage: 1,
                    limit: 20,
                    pageSize: 10,
                    importance: undefined,
                    title: undefined,
                    type: undefined,
                    sort: '+id'
                }
            }
        },
        methods: {
            onSubmit() {
                console.log('submit!');
            },
            //退出登录
            logout: function () {
                var _this = this;
                this.$confirm('确认退出吗?', '提示', {
                    //type: 'warning'
                }).then(() => {
                    sessionStorage.removeItem('user');
                    _this.$router.push('/login');
                }).catch(() => {

                });


            },
            //折叠导航栏
            collapse: function () {
                this.collapsed = !this.collapsed;
            },
            showMenu(i, status){
                this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
            },
            //获取维护项列表
            getMaintains() {
                let para = {
                    curPage: this.listQuery.curPage,
                    pageSize: this.listQuery.pageSize,
                    strOrder: 'asc'
                };
                this.listLoading = true;
                //NProgress.start();
                // getMaintainListPage(para).then((res) => {
                //     this.total = res.data.total;
                //     this.maintains = res.data.maintains;
                //     this.listLoading = false;
                //     //NProgress.done();
                // });
            },
            handleCurrentChange(val) {
                this.listQuery.curPage = val;
                this.getMaintains();
            },
            //删除
            handleDel: function (index, row) {
                this.$confirm('确认删除该记录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    //NProgress.start();
                    let para = {strMaintainId: row.strMaintainId};
                    removeMaintain(para).then((res) => {
                        this.listLoading = false;
                        //NProgress.done();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getMaintains();
                    });
                }).catch(() => {

                });
            },
            //延迟
            handleDelay: function (index, row) {
                //
            },
			//确认
            handleConfirm: function (index, row) {
                //
            },
            selsChange: function (sels) {
                this.sels = sels;
            },
            //操作分页
            handleSizeChange(val) {
                this.listQuery.pageSize = val;
                this.getMaintains();
            },
            handleCurrentChange(val) {
                this.listQuery.curPage = val;
                this.getMaintains();
            },
            //批量删除
            batchRemove: function () {
                var ids = this.sels.map(item => item.strMaintainId).toString();
                this.$confirm('确认删除选中记录吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.listLoading = true;
                    //NProgress.start();
                    let para = {ids: ids};
                    batchRemoveMaintain(para).then((res) => {
                        this.listLoading = false;
                        //NProgress.done();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getMaintains();
                    });
                }).catch(() => {

                });
            }
        },
        mounted() {
            // var loginUser =
            //     {
            //         avatar: 'https://avatars1.githubusercontent.com/u/16631463?v=4&s=460',
            //         name: 'admin'
            //     };
            // sessionStorage.setItem('user', JSON.stringify(loginUser));
            var user = sessionStorage.getItem('user');
			console.log('user-----------------------', user);
            if (user) {
                user = JSON.parse(user);
				this.isAdmin = (user.adminType == 1)
                this.sysUserName = user.name || '';
                // this.sysUserAvatar = user.avatar || 'https://hbimg.huabanimg.com/871aa2b9b0a55be3f0738d76a15e23ebac5c586811e29-B6Aozr_fw658';
				this.sysUserAvatar = user.avatar || 'https://img-qn.51miz.com/Element/00/38/03/97/917488dc_E380397_8f92a53e.png';
            }
            var _this = this;

            // window.setInterval(function () {
                _this.getMaintains();
            //     setTimeout(() => {
            //         if (!_this.dialogVisible) {
            //             _this.dialogVisible = true;
            //         } else {
            //             _this.dialogVisible = false;
            //         }
            //     }, 9000);
            // }, 5000);

        }
    }

</script>

<style scoped lang="scss">
	@import '~scss_vars';

	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		height: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: #ffffff;
			border-bottom: 6px solid #285ccd;
			.userinfo {
				text-align: right;
				padding-right: 20px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color: black;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				height: 60px;
				font-size: 22px;
				padding-left: 20px;
				padding-right: 20px;
				border-color: rgba(238, 241, 146, 0.3);
				border-right-width: 0px;
				border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color: #fff;
				}
			}
			.logo-width {
				width: 350px;
			}
			.logo-collapse-width {
				width: 60px
			}
			.tools {
				padding: 0px 23px;
				width: 14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
			.screenfull {
				vertical-align: middle;
				height: 60px;
				color: red;
			}
		}
		.main {
			display: flex;
			position: absolute;
			top: 0px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex: 0 0 230px;
				width: 230px;
				height: 100%;
				.el-menu {
					height: 100%;
					border-right: solid 0px #e6e6e6;
				}
				.collapsed {
					width: 60px;
					.item {
						position: relative;
					}
					.submenu {
						position: absolute;
						top: 0px;
						left: 60px;
						z-index: 99999;
						height: auto;
						display: none;
					}
				}
			}
			.menu-collapsed {
				flex: 0 0 60px;
				width: 60px;
			}
			.menu-expanded {
				flex: 0 0 230px;
				width: 230px;
			}
			.el-menu-item {
				min-width: 60px;
				color: $color-white;
				.fa {
					color: $color-white;
				}
				&:hover {
					background: green;
				}
				&.is-active {
					background-color: #273445 !important;
					border-right: 4px solid #273445;
					color: #4f9efd;
					.fa {
						color: #4f9efd;
					}
				}
			}
			.menu-all-list {
				& .el-submenu__title:hover {
					background: green;
				}
			}
			.menu-parent-list {
				// height: 45px;
				line-height: 45px;
				color: $color-white !important;
				.fa {
					color: $color-white;
				}
				&:hover {
					background: green;
				}
				.menu-list {
					height: 45px;
					line-height: 45px;
					background-color: #285ccdb0;
					color: $color-white;
					.fa {
						color: $color-white;
					}
					&:hover {
						background: green;
					}
					&.is-active {
						background-color: #273445 !important;
						border-right: 4px solid #273445;
						color: #4f9efd;
						.fa {
							color: #4f9efd;
						}
					}
				}
			}
			.menu-parent {
				color: $color-white !important;
			}
			.menu-child-list {
				background-color: #2f6cef !important;
				&:hover {
					background-color: #204aa4 !important;
				}
			}
			.menu-list {
				height: 45px;
				line-height: 45px;
				color: $color-white;
				.fa {
					color: $color-white;
				}
				&.is-active {
					background-color: #273445 !important;
					border-right: 4px solid #273445;
					color: #4f9efd;
					.fa {
						color: #4f9efd;
					}
				}
			}
			.small-menu-body {
				height: 100%;
				background-color: #285ccd;
			}
			.small-menu-list {
				height: 56px;
				line-height: 56px;
				background-color: #285ccd;
				color: $color-white;
				&:hover {
					background-color: #204aa4;
				}
				&.is-active {
					background-color: #16377d !important;
					border-right: 4px solid #16377d;
					color: #4f9efd;
				}
			}
			.small-menu-list-child {
				height: 56px;
				background-color: #2f6cef;
				color: $color-white;
				&:hover {
					background-color: #204aa4;
				}
				&.is-active {
					background-color: #16377d !important;
					border-right: 4px solid #16377d;
					color: #4f9efd;
				}
			}
			.content-container {
				flex: 1;
				overflow-y: scroll;
				.breadcrumb-container {
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}

	.all-title{
		width: 100%;
		height: 60px;
		background-color: #0e285f;
		color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
	}

	.simple-title{
		width: 100%;
		height: 60px;
		background-color: #0e285f;
		color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		font-size: 30px;
	}

	// .el-menu-vertical-demo {
	// 	background-image: linear-gradient(#0e285f, #285ccd);
	// }

</style>


// WEBPACK FOOTER //
// Home.vue?27aac7b4